/* import __COLOCATED_TEMPLATE__ from './settling-value-overlay.hbs'; */
import Component from '@ember/component';
import { service } from '@ember/service';

export default class SettlingValueOverlay extends Component {
    @service('data') model;

    tagName = '';
}
